<div fxLayout="column" class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}">
  <div fxLayoutAlign="center center" class="text-center layout-padd" *ngIf="!loader">
    <span class="mat-subheading">{{'PayzenComponent.infos'|translate}}  </span>
</div>

  <div style="padding: 25px; " fxLayoutAlign="center center">
    <div class="form">

      <div class="container">

        <div fxLayoutAlign="center center" *ngIf="loader">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-spinner diameter="20"></mat-spinner>
            <img src="assets/img/refonte-logo/PAYZEN.png"  class="h-10">
            <!-- <span class="mat-subheading-1 boldest">Payzen</span> -->
          </div>

        </div>

        <div id="myPaymentForm"  [ngStyle]="{'display': loader?'none':'block'}"></div>
        <div>{{ promiseError }}</div>


      </div>


    </div>

  </div>
  <button  *ngIf="!loader" fxFlex mat-stroked-button class="warn-ico" (click)="closeDial()" angulartics2On="click" angularticsAction="cancelPayzen" angularticsCategory="PayPayzen">
    {{"button.cancel"|translate}}
  </button>



</div>
